import React from "react";
import { func } from "prop-types";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Form,
  FormGroup,
  Label,
  Row,
  Col,
} from "reactstrap";
import _ from "lodash";
import Switch from "COMPONENTS/CommonComponents/Switch/Switch";

// Strings
import { getMessage } from "CONFIG/i18n";
import { validateUserName, validateString } from "UTILS/regexValidations";
import {USER_ROLES} from "UTILS/Constants";

import "../Organisations/AddOrganization.less";
import "../../App/App.less";
import "./AdminDashboard.less";
import modalScrollBar from "../../ModalScrollBar/ModalScrollBar";

class EditUserModal extends React.Component {
  static propTypes = {
    handleYesClick: func,
    handleNoClick: func
  };
  constructor(props) {
    super(props);
    this.state = {
      customerId: this.props.editUserData.id,
      first_name: this.props.editUserData.first_name,
      last_name: this.props.editUserData.last_name,
      role: this.props.editUserData.role,
      email: this.props.editUserData.email,
      isOperator: this.props.editUserData.isOperator,
      operatorSkills: this.props.editUserData.operatorSkills,
      originalSkills: this.props.originalSkills,
    };
  }

  componentDidUpdate(preProps) {
    if (
      preProps.editUserData.id !== this.props.editUserData.id
    ) {
      this.setState({ customerId: this.props.editUserData.id });
    }
    if (
      preProps.editUserData.first_name !== this.props.editUserData.first_name
    ) {
      this.setState({ first_name: this.props.editUserData.first_name });
    }
    if (preProps.editUserData.last_name !== this.props.editUserData.last_name) {
      this.setState({ last_name: this.props.editUserData.last_name });
    }
    if (preProps.editUserData.role !== this.props.editUserData.role) {
      this.setState({ role: this.props.editUserData.role });
    }
    if (preProps.editUserData.email !== this.props.editUserData.email) {
      this.setState({ email: this.props.editUserData.email });
    }
    if (preProps.editUserData.isOperator !== this.props.editUserData.isOperator) {
      this.setState({ isOperator: this.props.editUserData.isOperator });
    }
    if (!_.isEqual(preProps.editUserData.operatorSkills, this.props.editUserData.operatorSkills)) {
      this.setState({ operatorSkills: this.props.editUserData.operatorSkills });
    }
    if (!_.isEqual(preProps.originalSkills, this.props.originalSkills)) {
      this.setState({ originalSkills: this.props.originalSkills });
    }
    if (this.props.show != preProps.show && !this.props.show) {
      this.resetStateToPrevState();
    }
  }
  isValidData = () => {
    let UserDetail = this.state;
    if(!UserDetail.first_name || !UserDetail.first_name.trim()){
      this.setState({ errorMessage: getMessage("INVALID_FIRST_NAME") });
      return false;
    }
    if(!UserDetail.last_name || !UserDetail.last_name.trim()){
      this.setState({ errorMessage: getMessage("INVALID_LAST_NAME") });
      return false;
    }
    return true;
  };

  handleEditedSave = () => {
    let isSkillChanged = false;
    this.state.operatorSkills.forEach((skill, index) => {
      if (skill.isSelected !== this.state.originalSkills[index].isSelected) {
        isSkillChanged = true;
      }
    });
    if (
      this.state.first_name !== this.props.editUserData.first_name ||
      this.state.last_name !== this.props.editUserData.last_name ||
      this.state.role !== this.props.editUserData.role ||
      this.state.email !== this.props.editUserData.email ||
      this.state.isOperator !== this.props.editUserData.isOperator ||
      isSkillChanged
    ) {
      return true;
    } else return false;
  };

  handleSaveClick = () => {

    this.setState({ errorMessage: "" });
    if (!this.isValidData()) {
      return;
    }
    let data = Object.assign(
      {},
      {
        id: this.state.customerId,
        firstName: this.state.first_name.trim(),
        lastName: this.state.last_name.trim(),
        role: this.state.role,
        username: this.state.email.trim(),
        language: this.props.language,
        isOperator: this.state.isOperator,
        operatorSkills: this.state.operatorSkills,
      }
    );
    this.handleEditedSave()
      ? this.props.handleSaveClick(data, error => {
        this.setState({ errorMessage: error.message });
      })
      : this.props.handleCancelClick();
  };

  handleCancelClick = () => {
    this.resetStateToPrevState();
    this.props.handleCancelClick();
  };

  handleInputChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
    if (this.state.errorMessage) {
      this.setState({ errorMessage: "" });
    }
  };

  resetStateToPrevState = () => {
    this.setState({
      customerId: this.props.editUserData.id,
      first_name: this.props.editUserData.first_name,
      last_name: this.props.editUserData.last_name,
      role: this.props.editUserData.role,
      email: this.props.editUserData.email,
      errorMessage: "",
      isOperator: this.props.editUserData.isOperator,
      operatorSkills: _.cloneDeep(this.state.originalSkills),
    });
  };

  handleSwitch = () => {
    if (this.state.role === USER_ROLES.AGENT) {
      this.setState({
        isOperator: !this.state.isOperator,
      })
    } else {
      this.setState({
        isOperator: false,
      })
    }
  }

  renderSwitch = (flag) => {
    if (this.state.role === USER_ROLES.AGENT) {
      return (
        <Switch
          switchOn={flag}
          toggleSwitch={this.handleSwitch}
          disabled={false}
        />
      )
    } else {
      return (
        <Switch
          switchOn={false}
          toggleSwitch={this.handleSwitch}
          disabled={true}
        />
      )
    }
  }

  handleSkills = (evt) => {
    const id = evt.target.dataset.id;
    const newSkills = this.state.operatorSkills.map(skill => {
      if (skill.id == id) {
        skill.isSelected = !skill.isSelected;
      }
      return skill;
    });
    this.setState({
      operatorSkills: newSkills
    });
  }

  renderSkills = (skills) => {
    if (!skills || skills.length === 0 || this.state.role === USER_ROLES.ADMIN) return null;

    const elem = skills.map((skill) => {
      return (
        <Row key={skill.id}>
          <Col>
            <Input
              type={'checkbox'}
              name={'skills'}
              data-id={skill.id}
              checked={skill.isSelected}
              onChange={this.handleSkills}
            />
            {" "}
            {skill.name}
          </Col>
        </Row>
      )
    });

    return elem;
  }

  renderButtons = () => {
    return (
      <div className="permissionButtons">
        <Button
          className="buttons borderBtn bgwhite"
          onClick={this.handleCancelClick}
        >
          {getMessage("CANCEL")}
        </Button>{" "}
        <Button onClick={this.handleSaveClick} className="buttons customBtn whiteOnClick">
          {getMessage("SAVE")}
        </Button>
      </div>
    );
  };

  render() {
    return (
      <Modal
        isOpen={this.props.show}
        className="addOrganisationModal userAddModal"
        toggle={this.handleCancelClick}
        backdrop="static"
      >
        <ModalHeader className="popupHeader">
          {getMessage("EDIT_USER")}
        </ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label className="label modal-label">{getMessage("TYPE_OF_USER")}</Label>
              <Input
                type="text"
                name="role"
                id="role"
                className="inputFormControl"
                onChange={this.handleInputChange}
                defaultValue={_.capitalize(getMessage(this.state.role))}
                disabled
              />
            </FormGroup>
            <FormGroup>
              <Label className="label modal-label">{getMessage("ACCOUNT_ID")}</Label>
              <Input
                type="email"
                name="email"
                id="email"
                onChange={this.handleInputChange}
                className="inputFormControl"
                value={this.state.email}
                maxLength="50"
                disabled
              />
            </FormGroup>
            <FormGroup>
              <Label className="label modal-label">{getMessage("LAST_NAME")}</Label>
              <Input
                type="text"
                name="last_name"
                onChange={this.handleInputChange}
                className="inputFormControl"
                value={this.state.last_name}
                maxLength="50"
                disabled={this.props.editUserData.is_sso_user}
              />
            </FormGroup>
            <FormGroup>
              <Label className="label modal-label">{getMessage("FIRST_NAME")}</Label>
              <Input
                type="text"
                name="first_name"
                onChange={this.handleInputChange}
                className="inputFormControl"
                value={this.state.first_name}
                maxLength="50"
                disabled={this.props.editUserData.is_sso_user}
              />
            </FormGroup>
            {
              (this.props.isSupportCenter) ? (
                <FormGroup>
                  <Col xs={4} className="d-flex noPadding modal-label">
                    <Label className="label modal-label">{getMessage("OPERATOR")}</Label>
                    {this.renderSwitch(this.state.isOperator)}
                  </Col>
                </FormGroup>
              ) : null
            }
            {
              (this.props.isSupportCenter && this.state.isOperator && this.state.operatorSkills.length > 0)
                ? (
                  <FormGroup>
                    <Col xs={4} className="d-flex noPadding modal-label">
                      <Label className="label modal-label">{getMessage("SKILLS")}</Label>
                    </Col>
                    <Col className="d-flex flex-column">
                      {this.renderSkills(this.state.operatorSkills)}
                    </Col>
                  </FormGroup>
                ) : null
            }
            <div className="errors">{this.state.errorMessage}</div>
          </Form>
        </ModalBody>
        <ModalFooter className="permissionButtons">
          {this.renderButtons()}
        </ModalFooter>
      </Modal>
    );
  }
}

export default modalScrollBar(EditUserModal);
